import React from "react";

export default function AboutUs() {
  return (
    <div className="_w-100 text-bg-dark text-white pt-5 pb-5 mt-3 information min-vh-50">
      <div className="m-auto pt-3">
        <h2>Top Casino Picks UK</h2>
        <span>18+ | UK-Focused Casino Guidance</span>
        <div className="mt-3 ">
          <p>
            At <strong>TopCasinoPicksUK.com</strong>, we provide practical,
            up-to-date information for players across Great Britain who want to
            choose online casinos with confidence. Our team reviews operators,
            bonuses, games, and payment options with a UK-first mindset so you
            can compare what actually matters.
          </p>
          <p>
            We focus on trust, transparency, and player safety. That means
            highlighting casinos with clear terms, fair play standards, smooth
            withdrawals, and dependable customer support.
          </p>

          <h3 className="mt-4">What UK Players Get From Our Reviews</h3>
          <ul>
            <li>
              Clear comparisons of welcome offers, bonus terms, and wagering
              requirements.
            </li>
            <li>
              Payment insights based on methods commonly used in the UK,
              including debit cards, e-wallets, and bank transfer options.
            </li>
            <li>
              Game coverage across slots, table games, live casino, and
              mobile-friendly experiences.
            </li>
            <li>
              Straightforward notes on withdrawal speed, limits, and any fees to
              watch out for.
            </li>
          </ul>

          <h3 className="mt-4">Our Editorial Standards</h3>
          <p>
            We update our pages regularly to reflect changing bonus terms, new
            product features, and market updates. Our goal is to save your time
            and help you avoid poor-value offers.
          </p>

          <h3 className="mt-4">Responsible Gambling First</h3>
          <p>
            Gambling should be entertaining and controlled. We support safer
            gambling tools such as deposit limits, session reminders, time-outs,
            and self-exclusion. If you need support, consider resources such as
            GamCare, GAMSTOP, and BeGambleAware.
          </p>
          <p>
            Did you find our site helpful? Do you have suggestions for
            improvement? We would love to hear from you. Your feedback helps us
            improve Top Casino Picks UK for players in UK. Please reach out via
            our contact page or email us directly. We value your input and look
            forward to making your online casino experience better.
          </p>
        </div>
      </div>
    </div>
  );
}
